import type { PrimeVuePTOptions } from 'primevue/config'

export const GeneralPrimeVuePassthrough: PrimeVuePTOptions = {
  inputtext: {
    root: {
      class: ['py-2', 'px-2', 'placeholder:text-200']
    }
  }
}
